import { noop } from 'lodash'
import { useEffect, useRef, MutableRefObject } from 'react'
import { BROADCAST_CHANNEL } from 'constants/consts'

export const useBroadcastChannel = (
  channelName: string = BROADCAST_CHANNEL,
  onMessage?: (e: MessageEvent) => void,
  onMessageError?: (event: MessageEvent) => void
) => {
  const bc = useRef(new BroadcastChannel(channelName))

  useEffect(() => {
    bc.current = new BroadcastChannel(channelName)

    return () => {
      bc.current.close()
    }
  }, [])

  useChannelEventListener(bc, 'message', onMessage)
  useChannelEventListener(bc, 'messageerror', onMessageError)

  return bc.current
}

function useChannelEventListener<K extends keyof BroadcastChannelEventMap>(
  channelRef: MutableRefObject<BroadcastChannel | null>,
  event: K,
  handler: (e: BroadcastChannelEventMap[K]) => void = noop
) {
  useEffect(() => {
    const channel = channelRef.current
    if (channel) {
      channel.addEventListener(event, handler)
      return () => channel.removeEventListener(event, handler)
    }
  }, [channelRef, event, handler])
}
